import { render, staticRenderFns } from "./DetailCompany.vue?vue&type=template&id=69f40380"
import script from "./DetailCompany.vue?vue&type=script&lang=js"
export * from "./DetailCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports